import './js/main.js';
import GLightbox from "glightbox";

const header = document.querySelector('header.site-header');
if (header) {
    let headerLinks = document.querySelectorAll('.site-header .menu li a');
    headerLinks.forEach(function(link) {
        link.addEventListener('click', function() {
            header.classList.remove('is-open');
        });
    });
    let headerButtons = document.querySelectorAll('.site-header .btn');
    if (headerButtons.length > 0) {
        headerButtons.forEach(function(button) {
            button.addEventListener('click', function() {
                header.classList.remove('is-open');
            });
        });
    }
    document.querySelector('.menu-trigger').addEventListener('click', function(e) {
        header.classList.toggle('is-open');
    });
}

let mapContainer = document.getElementById('map');
if (mapContainer) {

  var map = L.map('map', {
    scrollWheelZoom: false
  }).setView([59.387806, 24.825156], 15);

  L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  }).addTo(map);

  map.zoomControl.setPosition('topright');


  let filters = document.querySelectorAll('.map-filters .filter');
  let categories = [];
  filters.forEach(filter => {
    categories.push({
      key: filter.dataset.key,
      label: filter.dataset.key,
      checked: true,
    });
  });

  const layers = {};
  const icons = {};

  categories.forEach(category => {
    layers[category.key] = L.layerGroup().addTo(map);
    icons[category.key] = L.icon({
      iconUrl: `/images/markers/${category.key}.svg`,
      iconSize: [40, 40],
      iconAnchor: [20, 40],
      popupAnchor: [0, -40]
    });
  });

  const mainIcon = L.icon({
    iconUrl: "/images/markers/peetriaru.svg",
    iconSize: [60, 60],
    iconAnchor: [20, 40],
    popupAnchor: [0, -40]
  });

  const mainMarker = L.marker([59.387806, 24.825156], {
    icon: mainIcon
  }).addTo(map);

  mainMarker.bindPopup("<b>Peetriaru</b><br>Krati tee 1, Peetri, Harjumaa<br><a target='_blank' href='https://maps.app.goo.gl/xAQ9qn4fCakjw7Qt5'>Ava Google Mapsis</a>").openPopup();

  locations.forEach(location => {
    const marker = L.marker([location.lat, location.lng],
      {
        icon: icons[location.type] ?? ''
      })
      .bindPopup(location.name);

    marker.addTo(layers[location.type]);
  });

  Object.values(layers).forEach(layer => layer.addTo(map));

  categories.forEach(category => {
    const checkbox = document.getElementById(`${category.key}-filter`);

    checkbox.addEventListener("change", () => {
      if (checkbox.checked) {
        map.addLayer(layers[category.key]);
      } else {
        map.removeLayer(layers[category.key]);
      }
    });

    if (checkbox.checked) {
      map.addLayer(layers[category.key]);
    } else {
      map.removeLayer(layers[category.key]);
    }
  });
}


/*L.marker([51.5, -0.09]).addTo(map)
    .bindPopup('A pretty CSS popup.<br> Easily customizable.')
    .openPopup();*/

const sectionSliders = document.querySelectorAll('.section-slider');
if (sectionSliders.length > 0) {
    import('./js/slider').then(Slider => {
        new Slider.default();
    }).catch(err => {
        console.error('Failed to load Slider module:', err);
    });
}

// if #showroomModal is present then add modalTrigger to open and get the href value

let showRoomModal = document.getElementById('showroomModal');
if (showRoomModal) {

    let modalLinks = document.querySelectorAll('.modal-link');
    // if modallinks follow the link and close modal
    if (modalLinks.length > 0) {
        document.addEventListener('click', function (e) {
            const link = e.target.closest('.modal-link');
            if (!link) return;
            e.preventDefault();
            window.location.href = link.getAttribute('href');
            showRoomModal.classList.remove('is-open');
        });
        /*
        modalLinks.forEach(function (link) {
            link.addEventListener('click', function (e) {
                alert('click');
                e.preventDefault();
                let href = this.getAttribute('href');
                window.location.href = href;
                showRoomModal.classList.remove('is-open');
            });
        });*/
    }


    let modalTrigger = document.querySelectorAll('.modalTrigger');
    modalTrigger.forEach(function (trigger) {
        trigger.addEventListener('click', function (e) {
            e.preventDefault();
            let href = this.getAttribute('href');
            let modalTitle = showRoomModal.querySelector('.modalTitle');
            let modalContent = showRoomModal.querySelector('.modalContent');
            let title = this.dataset.title;
            let content = document.querySelector(href);

            if (content) {
                modalTitle.innerText = title;
                modalContent.innerHTML = content.innerHTML;
                showRoomModal.classList.add('is-open');

              const lightbox = GLightbox({
                selector: '.glightbox'
              });

                let imageArea = showRoomModal.querySelector('.image-area');
                if (imageArea) {
                    let mainImage = imageArea.querySelector('.main-image img');

                    let thumbs = imageArea.querySelectorAll('.thumb');
                    if (thumbs.length > 0) {
                        thumbs.forEach(function (thumb) {
                            thumb.addEventListener('click', function () {

                                //mainImage.src = this.src;
                                mainImage.src = this.dataset.image;
                            });
                        });
                    }
                }
            }

        });
    });

    let close = showRoomModal.querySelector('.close');
    close.addEventListener('click', function () {
        showRoomModal.classList.remove('is-open');
    });

    // add escape key press to close modal
    document.addEventListener('keydown', function (e) {
        if (e.key === "Escape") {
            showRoomModal.classList.remove('is-open');
        }
    });



}
